import CentricDispatcher from '../dispatcher/CentricDispatcher.react';
import { ActionTypes } from '../constants/CentricConstants';
import EventEmitter from 'events';
import assign from 'object-assign';

const CHANGE_EVENT = 'change';

let _periodicTypes = [];

let PeriodicTypeStore = assign({}, EventEmitter.prototype, {

    emitChange: function() {
        this.emit(CHANGE_EVENT);
    },
    addChangeListener: function(callback) {
        this.on(CHANGE_EVENT, callback);
    },
    removeChangeListener: function(callback) {
        this.removeListener(CHANGE_EVENT, callback);
    },
    addListener: function(callback) {
        this.addChangeListener(callback);
        return { remove: () => this.removeChangeListener(callback) };
    },
    getAll: function() {
        return _periodicTypes;
    }
});

PeriodicTypeStore.dispatchToken = CentricDispatcher.register(function(action) {

    switch(action.type) {

        case ActionTypes.PERIODIC_TYPE_LIST:
            _periodicTypes = action.data;
            PeriodicTypeStore.emitChange();
            break;

        case ActionTypes.PERIODIC_TYPE_LIST_ERROR:
            PeriodicTypeStore.emitChange();
            break;

        default:
            break;

    }

});

export default PeriodicTypeStore;
